import * as React from 'react';
import type { ChartContextValue } from './types';

const ChartContext = React.createContext<ChartContextValue>({
  config: {},
});

export function useChartConfig() {
  return React.useContext(ChartContext);
}

export default ChartContext;
